import { useEffect, useState } from 'react';
import { managerApi } from '../../lib/api';

export function DashboardTab() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    managerApi.getDashboard().then(setData).finally(() => setLoading(false));
  }, []);

  if (loading || !data) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <h2>Hoje</h2>
        <p className="hint">Panorama de quem está em dia e quem ainda tem pendências.</p>
      </div>
      {data.sosAbertos > 0 && (
        <div className="card" style={{ background: 'var(--coral)', color: '#fff' }}>
          <h2 style={{ color: '#fff', margin: 0 }}>🚨 {data.sosAbertos} pedido(s) de ajuda em aberto — veja a aba "Ao vivo"</h2>
        </div>
      )}
      <div className="stat-grid">
        <div className="stat-tile"><div className="num">{data.totalAtivos}</div><div className="lbl">Funcionários ativos</div></div>
        <div className="stat-tile good"><div className="num">{data.pontoCompleto}</div><div className="lbl">Ponto completo</div></div>
        <div className="stat-tile warn"><div className="num">{data.pontoPendente}</div><div className="lbl">Ponto pendente</div></div>
        <div className="stat-tile warn"><div className="num">{data.alimPendente}</div><div className="lbl">Alimentação pendente</div></div>
        <div className="stat-tile warn"><div className="num">{data.recvPendente}</div><div className="lbl">Recebimentos pendentes</div></div>
      </div>
      <div className="card">
        <h2>Trocas de PIN recentes ("esqueci meu PIN")</h2>
        {data.pinResets.length === 0 && <p className="hint">Nenhuma troca recente.</p>}
        {data.pinResets.map((r: any, i: number) => (
          <div className="kv" key={i}><span>{r.nome}</span><span>{new Date(r.criadoEm).toLocaleString('pt-BR')}</span></div>
        ))}
      </div>
    </>
  );
}
